import { useGenericRequestHandler } from '../../handlers/useGenericRequestHandler'
import { REFERRER_KEY } from '@mote/helpers/constants'
import { getReferrer } from 'web/src/shared/AnalyticsHelpers'
import { getTZOffset } from 'web/src/shared/Utils'

export const useLoginMutation = () => {
  return useGenericRequestHandler({
    route: `v1/i/signIn/IDPAuthCode`,
    method: 'POST',
    options: {
      json: {
        identityProvider: 'google',
        [REFERRER_KEY]: getReferrer(),
        TZOffset: getTZOffset(),
        lastLoginHostname: window.location.hostname
      }
    }
  })
}
